export default __webpack_public_path__ + "static/landscape-2a47f5a4ddfca6023809cb8f3c67faa7.jpg";